<template>
    <div class="MAM_flowCard">
        <el-dialog
            title="阶段性流量卡设置"
            width="800px"
            :visible="flowCard.isShow"
            :close-on-click-modal="false"
            @close="handleClose"
        >
            <!-- 活动说明 -->
            <div style="margin-top:10px">
              <el-tag type="danger"> 温馨提示：自商户入网之日起叠加扣款天数进行扣款（解绑后重新绑机会重新计算）</el-tag>
            </div>
            <!-- 表单部分 -->
            <el-form label-position="top" label-width="80px" :model="flowCardForm">
                <el-form-item>
                    <el-table :data="setting" border max-height="456px">
                        <el-table-column
                            header-align="center"
                            align="center"
                            width="120"
                            type="index"
                            label="模板ID"
                        ></el-table-column>
                        
                        <!-- <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="flow_card_step"
                            label="流量卡名称"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.flow_card_step"  placeholder="请选择" :disabled="scope.row.brand_reward_conf_id != ''">
                                    <el-option v-for="item in flow_card_step_list" 
                                    :label="item.name"
                                    :value="item.step" 
                                    >
                                   </el-option>
                                </el-select>   
                            </template>
                        </el-table-column> -->

                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="target_money"
                            label="扣费金额"
                        >
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.target_money"  placeholder="请选择">
                                    <el-option v-for="item in flow_card_money_list" 
                                    :label="item.name"
                                    :value="item.money" 
                                    >
                                   </el-option>
                                </el-select>   
                            </template>
                        </el-table-column>
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="reward_money"
                            label="返现金额"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    v-model="scope.row.reward_money"
                                ></el-input>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            prop="days"
                            label="扣款时间(月)"
                        >
                            <template slot-scope="scope">
                               <!-- <el-input
                                    v-model="scope.row.days"
                                ></el-input> -->
                                <el-select v-model="scope.row.days"  placeholder="请选择">
                                    <el-option v-for="index in months" 
                                    :label="index"
                                    :value="index" 
                                    >
                                   </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        
                        <el-table-column
                            header-align="center"
                            align="center"
                            min-width="120"
                            label="操作"
                        >
                            <template slot-scope="scope">
                                <el-button
                                    v-if="setting.length > 1"
                                    @click="handleDel(scope.row,scope.$index)"
                                    type="text"
                                    size="small"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item v-if="setting.length < 10">
                    <el-button
                        type="text"
                        icon="el-icon-plus"
                        @click="handleAdd"
                    >增加模板</el-button>
                </el-form-item>
                
                <el-form-item style="margin-top:20px;">
                    <el-button
                        type="primary"
                        @click="handleSubmit"
                    >提 交</el-button>
                    <div style="margin-top:10px">
                        <el-tag type="danger">温馨提示：模版最多配置10条。</el-tag>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "nextYearFlowCard",
    props: {
        flowCard: {
            type: Object
        },
        brandId: {
            type: [String, Number]
        }
    },
    data() {
        return {
            setting: [],
            flowCardForm: {
            },
            flow_card_step_list:[],
            flow_card_money_list:[],
            months:[]
        };
    },
    mounted() {
        this.getInfo();
        for (let i = 6; i < 49; i++) {
            this.months.push(i)
        }
    },
    methods: {
        handleSubmit() { //提交
            let that = this;
            this.flowCardForm.setting = JSON.stringify(this.setting);
            this.flowCardForm.brand_id = this.brandId;
            this.$confirm('请确认是否添加？', '提示', {
                confirmButtonText: '确 认',
                cancelButtonText: '取 消',
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        this.$api.post('brand/updateStepFlowCardReward', this.flowCardForm, res => {
                            if (res.code == 0) {
                                this.$message.success({
                                    type: 'success',
                                    message: res.msg,
                                    duration: 1500,
                                    onClose() {
                                        done();
                                        that.handleClose(1);
                                        instance.confirmButtonLoading = false;
                                    }
                                });
                            } else {
                                this.$message.error(res.msg);
                                done();
                                instance.confirmButtonLoading = false;
                            }
                        });
                    } else {
                        done();
                        instance.confirmButtonLoading = false;
                    }
                }
            }).then(() => {

            }).catch(() => { });
        },
        handleAdd() { //增加交易量奖励规则
            this.setting.push({
                brand_reward_conf_id: "",
                target_money: "",
                reward_money: "",
                days: '',
                flow_card_step: '',
            });
        },

        handleDel(row, index) { //删除
            this.$confirm('确定删除该模板吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.setting.splice(index, 1);
            }).catch(() => {

            })
        },
        
        handleClose(ref) { //关闭弹窗
            this.$emit('flowCardClose', ref)
        },
        getInfo() { //初始化
            this.$api.post('brand/stepFlowCardRewardDetail', { brand_id: this.brandId }, res => {
                if (res.code === 0) {
                    let data = res.data;
                    for (let item of data.setting) {
                        item.flow_card_step = item.flow_card_step + ''
                    }
                    this.flowCardForm = data;
                    this.setting = data.setting;
                    this.flow_card_money_list = data.flow_card_money_list;
                    this.flow_card_step_list = data.flow_card_step_list; 
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.MAM_flowCard * {
    font-size: 12px;
    // .el-input__inner {
    //     font-size: 12px;
    // }
    ::v-deep .el-dialog__body {
        height: 600px;
        overflow: auto;
    }
    ::v-deep .el-form-item {
        margin-bottom: 5px;
        .el-form-item__label,
        .el-radio__label {
            font-size: 12px;
        }
    }
    .el-form--label-top ::v-deep .el-form-item__label {
        padding: 0;
    }
    .el-checkbox ::v-deep .el-checkbox__label {
        font-size: 12px;
    }
}
</style>